import React, { useState, useEffect, useMemo } from 'react';
import { db } from '../firebase';
import { collection, onSnapshot, addDoc, serverTimestamp, query, where, getDocs, doc, setDoc, orderBy, limit } from 'firebase/firestore';
import { KKTC_BOLGELERI } from '../constants/bolgeler';

const OrderPage = () => {
    const [customer, setCustomer] = useState({ phone: '', name: '', address: '', cityId: '', district: '' });
    const [cart, setCart] = useState([]);
    const [stoklar, setStoklar] = useState([]);
    const [deliveryType, setDeliveryType] = useState('DEVAY');
    const [filtreKategori, setFiltreKategori] = useState("HEPSİ");
    const [aramaTerimi, setAramaTerimi] = useState("");
    const [customerHistory, setCustomerHistory] = useState([]); // Geçmiş siparişler için

    const [packTypes] = useState([
        { "id": 206, "name": "5 litre zeytinyağı adet", "type": "Koli", "price": "220.00", "desi": "5" },
        { "id": 227, "name": "2 adet", "type": "Koli", "price": "280.00", "desi": "5 >" },
        { "id": 228, "name": "3 Adet ve üzeri", "type": "Koli", "price": "350.00", "desi": "10 >" },
        { "id": 263, "name": "Odun ve bidon", "type": "Koli", "price": "650.00", "desi": "50" }
    ]);
    const [selectedPackType, setSelectedPackType] = useState(206);

    const kategoriler = ["HEPSİ", "ZEYTİNYAĞI", "ZEYTİN", "KOZMETİK", "YAKACAK", "MAKİNA", "SAKLAMA KABI", "HİZMET", "AMBALAJ", "DİĞER", "ÖZEL SERİ", "İNDİRİMLİ"];

    // Ürünleri Dinle
    useEffect(() => {
        const unsub = onSnapshot(collection(db, "urunler"), (snapshot) => {
            setStoklar(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        });
        return () => unsub();
    }, []);

    // OTOMATİK MÜŞTERİ BULMA VE GEÇMİŞ GETİRME
    useEffect(() => {
        const phoneClean = customer.phone.trim();
        if (phoneClean.length >= 10) {
            const fetchCustomerData = async () => {
                const q = query(collection(db, "musteriler"), where("tel", "==", phoneClean));
                const snap = await getDocs(q);

                if (!snap.empty) {
                    const data = snap.docs[0].data();
                    setCustomer(prev => ({
                        ...prev,
                        name: data.adSoyad || '',
                        address: data.adres || '',
                        cityId: data.cityId || '',
                        district: data.district || ''
                    }));

                    // Müşterinin son siparişlerini getir
                    const qSiparis = query(
                        collection(db, "siparisler"),
                        where("customer.phone", "==", phoneClean),
                        orderBy("createdAt", "desc"),
                        limit(3)
                    );
                    const siparisSnap = await getDocs(qSiparis);
                    setCustomerHistory(siparisSnap.docs.map(d => ({ id: d.id, ...d.data() })));
                }
            };
            fetchCustomerData();
        } else {
            setCustomerHistory([]);
        }
    }, [customer.phone]);

    const total = cart.reduce((acc, item) => acc + (Number(item.fiyat) * item.qty), 0);

    const filtrelenmisStok = useMemo(() => {
        return stoklar.filter(u => {
            const adUygun = (u.ad || "").toLowerCase().includes(aramaTerimi.toLowerCase());
            const katUygun = filtreKategori === "HEPSİ" || (Array.isArray(u.kategori) ? u.kategori.includes(filtreKategori) : u.kategori === filtreKategori);
            return adUygun && katUygun;
        }).sort((a, b) => (a.ad || "").localeCompare(b.ad));
    }, [stoklar, aramaTerimi, filtreKategori]);

    const addToCart = (product) => {
        if (!product.isHizmet && product.stok <= 0) return alert("Stokta Yok!");
        const existing = cart.find(item => item.id === product.id);
        if (existing) {
            setCart(cart.map(item => item.id === product.id ? { ...item, qty: item.qty + 1 } : item));
        } else {
            setCart([...cart, { ...product, qty: 1 }]);
        }
    };

    const handleFinishOrder = async () => {
        if (!customer.phone || !customer.name || cart.length === 0) {
            alert("Lütfen Müşteri Bilgilerini ve Ürünleri Kontrol Edin!");
            return;
        }

        try {
            const urunAciklamasi = cart.map(item => `${item.qty} ADET ${item.ad}`).join(', ');
            let kargoNo = "BEKLEMEDE";
            const seciliSehir = KKTC_BOLGELERI.find(b => b.id.toString() === customer.cityId.toString());

            // --- MAXPRESS BÖLÜMÜ (DOKUNULMADI) ---
            if (deliveryType === 'MAXPRESS') {
                const apiToken = '49b2bba5-9877-48de-9782-23c1a3f69892'; // Token korundu
                const response = await fetch("https://maxpress.com.tr/api/external/cargoes-store", {
                    method: 'POST',
                    headers: { 'x-api-key': apiToken, 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        packageType: selectedPackType,
                        full_name: customer.name,
                        phone: customer.phone,
                        address: `${customer.district} - ${customer.address}`,
                        city_id: parseInt(customer.cityId),
                        is_payment_on_delivery: true,
                        package_price: total.toString(),
                        desc: urunAciklamasi,
                        packages_count: 1
                    })
                });
                const apiResult = await response.json();
                if (apiResult.status === 'success') {
                    kargoNo = apiResult.id;

                    // Maxpress operasyon listesine de düşsün diye kargolar tablosuna ekliyoruz
                    await addDoc(collection(db, "kargolar"), {
                        adSoyad: customer.name,
                        ilce: seciliSehir?.name || "",
                        koy: customer.district,
                        adres: customer.address,
                        tel: customer.phone,
                        paketAdet: "1",
                        aciklama: urunAciklamasi,
                        tutar: total.toString(),
                        durum: "HAZIRLANACAK", // Operasyon ekranı için
                        tarih: new Date().toISOString(),
                        kargo: "MAXPRESS",
                        kargoNo: kargoNo,
                        kaynak: "SİPARİŞ PANELİ"
                    });
                } else {
                    throw new Error(apiResult.message || "MaxPress API Hatası");
                }
            }

            // --- DEVAY BÖLÜMÜ ---
            if (deliveryType === 'DEVAY') {
                kargoNo = "DEVAY_KARGO";
                await addDoc(collection(db, "kargolar"), {
                    adSoyad: customer.name,
                    ilce: seciliSehir?.name || "",
                    koy: customer.district,
                    adres: customer.address,
                    tel: customer.phone,
                    paketAdet: "1",
                    aciklama: urunAciklamasi,
                    tutar: total.toString(),
                    durum: "HAZIRLANACAK", // Operasyon ekranı için
                    tarih: new Date().toISOString(),
                    kargo: "DEVAY",
                    kaynak: "SİPARİŞ PANELİ"
                });
            }

            // Müşteri güncelleme ve Arşivleme kısımları aynı kalıyor...
            const mustRef = doc(db, "musteriler", customer.phone.trim());
            await setDoc(mustRef, {
                tel: customer.phone.trim(),
                adSoyad: customer.name,
                adres: customer.address,
                cityId: customer.cityId,
                district: customer.district,
                lastOrder: serverTimestamp()
            }, { merge: true });

            await addDoc(collection(db, "siparisler"), {
                customer, cart, total, deliveryType, kargoNo,
                status: 'HAZIRLANACAK',
                createdAt: serverTimestamp()
            });

            alert(`✅ SİPARİŞ TAMAMLANDI!\nOperasyon Listesine Gönderildi.`);
            setCart([]);
            setCustomer({ phone: '', name: '', address: '', cityId: '', district: '' });

        } catch (error) {
            alert("Hata Oluştu: " + error.message);
        }
    };

    return (
        <div style={{ display: 'grid', gridTemplateColumns: '360px 1fr', height: '92vh', gap: '15px', padding: '15px', background: '#020617', color: 'white', boxSizing: 'border-box' }}>
            <div style={{ background: '#0f172a', borderRadius: '30px', padding: '25px', display: 'flex', flexDirection: 'column', border: '1px solid #1e293b', overflowY: 'auto' }}>
                <h2 style={{ color: '#3b82f6', fontWeight: '900', fontSize: '1.2rem', marginBottom: '20px', borderBottom: '1px solid #1e293b', paddingBottom: '10px' }}>👤 MÜŞTERİ BİLGİLERİ</h2>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <input placeholder="TELEFON" value={customer.phone} onChange={e => setCustomer({ ...customer, phone: e.target.value })} style={inputStyle} />
                    <input placeholder="AD SOYAD" value={customer.name} onChange={e => setCustomer({ ...customer, name: e.target.value.toUpperCase() })} style={inputStyle} />

                    <div style={{ display: 'flex', gap: '10px' }}>
                        <select value={customer.cityId} onChange={e => setCustomer({ ...customer, cityId: e.target.value, district: '' })} style={inputStyle}>
                            <option value="">ŞEHİR</option>
                            {KKTC_BOLGELERI.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
                        </select>
                        <select value={customer.district} disabled={!customer.cityId} onChange={e => setCustomer({ ...customer, district: e.target.value })} style={inputStyle}>
                            <option value="">BÖLGE</option>
                            {customer.cityId && KKTC_BOLGELERI.find(b => b.id.toString() === customer.cityId.toString())?.koyler.map(k => <option key={k} value={k}>{k}</option>)}
                        </select>
                    </div>

                    <textarea placeholder="ADRES DETAYI" value={customer.address} onChange={e => setCustomer({ ...customer, address: e.target.value })} style={{ ...inputStyle, minHeight: '80px', resize: 'none' }} />

                    {/* GEÇMİŞ SİPARİŞLER GÖSTERİMİ */}
                    {customerHistory.length > 0 && (
                        <div style={{ background: '#1e293b55', padding: '12px', borderRadius: '15px', border: '1px solid #334155', marginTop: '5px' }}>
                            <div style={{ fontSize: '10px', fontWeight: '900', color: '#fb923c', marginBottom: '8px' }}>📜 SON SİPARİŞLERİ</div>
                            {customerHistory.map(h => (
                                <div key={h.id} style={{ fontSize: '11px', color: '#94a3b8', marginBottom: '4px', borderBottom: '1px solid #1e293b' }}>
                                    {h.total}₺ - {h.deliveryType} ({new Date(h.createdAt?.seconds * 1000).toLocaleDateString('tr-TR')})
                                </div>
                            ))}
                        </div>
                    )}

                    {deliveryType === 'MAXPRESS' && (
                        <div style={{ marginTop: '10px' }}>
                            <label style={{ fontSize: '10px', fontWeight: '900', color: '#3b82f6', display: 'block', marginBottom: '5px' }}>📦 MAXPRESS PAKET TİPİ</label>
                            <select value={selectedPackType} onChange={e => setSelectedPackType(Number(e.target.value))} style={{ ...inputStyle, border: '1px solid #3b82f6', width: '100%' }}>
                                {packTypes.map(p => <option key={p.id} value={p.id}>{p.name.toUpperCase()}</option>)}
                            </select>
                        </div>
                    )}

                    <div style={{ marginTop: '10px' }}>
                        <label style={{ fontSize: '10px', fontWeight: '900', color: '#64748b', display: 'block', marginBottom: '8px' }}>TESLİMAT TİPİ</label>
                        <div style={{ display: 'flex', gap: '5px' }}>
                            {['STORE', 'DEVAY', 'MAXPRESS'].map(type => {
                                const isStore = type === 'STORE';
                                return (
                                    <button
                                        key={type}
                                        onClick={() => !isStore && setDeliveryType(type)}
                                        style={{
                                            flex: 1,
                                            padding: '12px 5px',
                                            borderRadius: '12px',
                                            fontSize: '10px',
                                            fontWeight: '900',
                                            border: '1px solid #334155',
                                            cursor: isStore ? 'not-allowed' : 'pointer',
                                            background: isStore ? '#1e293b' : (deliveryType === type ? '#3b82f6' : '#020617'),
                                            color: isStore ? '#334155' : (deliveryType === type ? 'white' : '#64748b'),
                                            opacity: isStore ? 0.5 : 1,
                                            pointerEvents: isStore ? 'none' : 'auto'
                                        }}
                                    >
                                        {type}
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                </div>

                <div style={{ marginTop: '20px', borderTop: '2px solid #1e293b', paddingTop: '20px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '15px' }}>
                        <span style={{ fontSize: '12px', color: '#64748b', fontWeight: 'bold' }}>TOPLAM TUTAR</span>
                        <span style={{ fontSize: '32px', fontWeight: '900', color: '#10b981' }}>₺{total}</span>
                    </div>
                    <button onClick={handleFinishOrder} disabled={cart.length === 0} style={{ width: '100%', padding: '20px', borderRadius: '20px', background: '#f97316', color: 'white', fontWeight: '900', fontSize: '1.2rem', border: 'none', cursor: 'pointer', opacity: cart.length === 0 ? 0.3 : 1 }}>SİPARİŞİ TAMAMLA</button>
                </div>
            </div>

            <div style={{ display: 'grid', gridTemplateRows: '220px 1fr', gap: '15px', overflow: 'hidden' }}>
                <div style={{ background: '#1e293b77', borderRadius: '30px', padding: '15px', display: 'flex', flexDirection: 'column', border: '1px solid #1e293b' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #334155', paddingBottom: '8px', marginBottom: '10px' }}>
                        <span style={{ fontWeight: '900', color: '#fb923c', fontSize: '0.9rem' }}>🛒 SEPET</span>
                        <button onClick={() => setCart([])} style={{ background: 'none', color: '#ef4444', border: 'none', cursor: 'pointer', fontSize: '10px', fontWeight: 'bold' }}>TEMİZLE</button>
                    </div>
                    <div style={{ flex: 1, overflowY: 'auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '10px' }}>
                        {cart.map(item => (
                            <div key={item.id} style={{ background: '#0f172a', padding: '12px', borderRadius: '15px', fontSize: '12px', border: '1px solid #334155', display: 'flex', justifyContent: 'space-between' }}>
                                <div><b>{item.ad}</b><br /><span style={{ color: '#10b981' }}>₺{item.fiyat} x {item.qty}</span></div>
                                <button onClick={() => setCart(cart.filter(c => c.id !== item.id))} style={{ color: '#ef4444', border: 'none', background: 'none', cursor: 'pointer' }}>✕</button>
                            </div>
                        ))}
                    </div>
                </div>

                <div style={{ background: '#0f172a', borderRadius: '30px', display: 'flex', flexDirection: 'column', overflow: 'hidden', border: '1px solid #1e293b' }}>
                    <div style={{ padding: '15px', background: '#1e293b44' }}>
                        <input placeholder="Ürün ara..." value={aramaTerimi} onChange={e => setAramaTerimi(e.target.value)} style={{ ...inputStyle, width: '100%', marginBottom: '10px' }} />
                        <div style={{ display: 'flex', gap: '8px', overflowX: 'auto' }}>
                            {kategoriler.map(k => (
                                <button key={k} onClick={() => setFiltreKategori(k)} style={{ whiteSpace: 'nowrap', padding: '6px 15px', borderRadius: '20px', fontSize: '10px', fontWeight: '900', border: '1px solid #334155', background: filtreKategori === k ? 'white' : '#020617', color: filtreKategori === k ? 'black' : '#64748b' }}>{k}</button>
                            ))}
                        </div>
                    </div>
                    <div style={{ flex: 1, overflowY: 'auto', padding: '20px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                        {filtrelenmisStok.map(prod => (
                            <div key={prod.id} onClick={() => addToCart(prod)} style={{ background: '#1e293b33', padding: '20px', borderRadius: '25px', border: '1px solid #1e293b', cursor: 'pointer', display: 'flex', justifyContent: 'space-between' }}>
                                <div>
                                    <div style={{ fontSize: '10px', color: '#64748b', fontWeight: '900' }}>{prod.ad}</div>
                                    <div style={{ fontSize: '22px', fontWeight: '900' }}>₺{prod.fiyat}</div>
                                    <div style={{ fontSize: '10px', color: prod.stok <= 0 && !prod.isHizmet ? '#ef4444' : '#3b82f6' }}>STOK: {prod.isHizmet ? '∞' : prod.stok}</div>
                                </div>
                                <div style={{ background: '#3b82f622', color: '#3b82f6', width: '40px', height: '40px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px' }}>+</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

const inputStyle = {
    background: '#020617',
    border: '1px solid #334155',
    color: 'white',
    padding: '14px',
    borderRadius: '15px',
    outline: 'none',
    fontWeight: 'bold',
    fontSize: '13px',
    boxSizing: 'border-box'
};

export default OrderPage;